import { render, staticRenderFns } from "./amenities.vue?vue&type=template&id=7387e971"
import script from "./amenities.vue?vue&type=script&lang=js"
export * from "./amenities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports